module.exports = __webpack_public_path__ + "img/home_icon_suoding_nor.988a1dbf.png";